import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IconName } from '@app/utils/enums/icon-enum';
import { ICON_PATH } from '@app/utils/constants/icon-map.constants';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  public IconName = IconName;
  public icons = ICON_PATH;
  private readonly dialogRef = inject(MatDialogRef<ErrorModalComponent>);
  public data = inject<{ message: string }>(MAT_DIALOG_DATA);

  public closeModal(): void {
    this.dialogRef.close();
  }
}
